import axios, {AxiosResponse} from 'axios';

import {loadProgressBar} from 'axios-progress-bar';
import session from '@/stores/Session';
import stores from '@/stores';
import {mergeLocalization} from '@/helpers/helpers';
import { bus } from './functions';
// TODO sej bi lahko v session.project shranil kar objekt z vsemi nastavitami?

console.log( "session project url: " + ( session.project === null ? '' : session.project!.url ) );
const axiosInstance = axios.create(
  {
    baseURL: session.project === null ? '' : session.project!.url,
  }
);

if (session.project)
{
  axiosInstance.interceptors.request.use(
    (request) =>
    {
    //Set headers.
	//
	//Notice:
	//Add additional headers to any existing request header.
      const headers = request.headers || {};

      headers['Authorization'] = 'Bearer ' + sessionStorage.getItem(session.project!.id + '-token');
      headers['X-Project'] = session.project!.id;
      headers['Accept'] = 'application/json';

      return request;
    }
  );
}

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) =>
  {
    if (
      response.config.method
      &&
      ['put', 'patch', 'post'].includes(response.config.method)
    )
    {
      bus().$on(
        'login',
        () =>
        {
          stores.Language.loadTranslations();
        }
      );
      if (!response.data.isSuperAdmin)
      {
        stores.Language.loadTranslations();

        if (!response.data.accessToken)
        {
          let translatables = '';

          if (response.data.dashboard)
          {
          // tslint:disable-next-line:no-shadowed-variable
            stores.Language.loadTranslations();
          }
          else
          {
            translatables = response.data.data !== undefined ? response.data.data.translatables : '';

            if (translatables !== undefined)
            {
              mergeLocalization(translatables);
            }
            if (response.data.data?.loadTranslation !== undefined)
            {
              stores.Language.loadTranslations();
            }
          }
        }
      }
    }
    if (response.data && response.data.error)
    {
      console.error(response.data.error);
    }

    return response;
  }
);

loadProgressBar(
  {
    showSpinner: false,
  },
  axiosInstance,
);
export default axiosInstance;
